export default __webpack_public_path__ + "0cbb2f4d362d5a86dceae22d64155422.webp";